import axios from 'axios';

const init = function (state, longitude, latitude) {
    window._AZURE_MAP = {
        map               : null,
        popup             : null,
        dataSources       : {},
        layers            : {},
        boundingList      : [],
        geoCodedSearchData: null
    };

    window._AZURE_MAP.map = new atlas.Map('azure-map', {
        style            : 'grayscale_light',
        zoom             : 5,
        center           : [longitude, latitude],
        language         : 'en-US',
        renderWorldCopies: false,
        authOptions      : {
            authType       : 'subscriptionKey',
            subscriptionKey: window._AZURE_KEY
        },
        maxZoom: 15,
        minZoom: 5,
    });

    window._AZURE_MAP.map.setUserInteraction({ 
        scrollZoomInteraction: false 
    });
    
    window._AZURE_MAP.dataSources = {};
    window._AZURE_MAP.layers = {};

    window._AZURE_MAP.showPopup = showPopup;

};

const addEventListeners = function (onClickCallback) {
    window._AZURE_MAP.map.events.add('ready', () => {
        window._AZURE_MAP.popup = new atlas.Popup();

        makeDataSource('CORE');
        makeDataSource('CERT');
        makeDataSource('PREM');
        makeDataSource('MFE');
        makeDataSource('RETAILER');

        window._AZURE_MAP.map.imageSprite.add('pin-core', window.LocatorConfig.imagePath.replace('__FILE__', 'storelocator_images/pin_core.png'));
        window._AZURE_MAP.map.imageSprite.add('pin-prem', window.LocatorConfig.imagePath.replace('__FILE__', 'storelocator_images/pin_prem.png'));
        window._AZURE_MAP.map.imageSprite.add('pin-cert', window.LocatorConfig.imagePath.replace('__FILE__', 'storelocator_images/pin_cert.png'));
        window._AZURE_MAP.map.imageSprite.add('pin-mfe', window.LocatorConfig.imagePath.replace('__FILE__', 'storelocator_images/pin_mfe.png'));
        window._AZURE_MAP.map.imageSprite.add('pin-retailer', window.LocatorConfig.imagePath.replace('__FILE__', 'storelocator_images/pin_retailer.png'));

        makeLayer('CORE', 'pin-core');
        makeLayer('CERT', 'pin-cert');
        makeLayer('PREM', 'pin-prem');
        makeLayer('MFE', 'pin-mfe');
        makeLayer('RETAILER', 'pin-retailer');

        window._AZURE_MAP.map.controls.add(new atlas.control.ZoomControl(), {
            position: 'top-right'
        });

        // window._AZURE_MAP.map.events.add('mouseover', [
        //     window._AZURE_MAP.layers['RETAILER'],
        //     window._AZURE_MAP.layers['MFE'],
        //     window._AZURE_MAP.layers['CORE'],
        //     window._AZURE_MAP.layers['CERT'],
        //     window._AZURE_MAP.layers['PREM']
        // ], function (e) {
        //     window._AZURE_MAP.showPopup(e.shapes[0]);
        // });

        window._AZURE_MAP.map.events.add('mouseover', [
            window._AZURE_MAP.layers['RETAILER'],
            window._AZURE_MAP.layers['MFE'],
            window._AZURE_MAP.layers['CORE'],
            window._AZURE_MAP.layers['CERT'],
            window._AZURE_MAP.layers['PREM']
        ], function () {
            window._AZURE_MAP.map.getCanvasContainer().style.cursor = 'pointer';
        });

        window._AZURE_MAP.map.events.add('mouseout', [
            window._AZURE_MAP.layers['RETAILER'],
            window._AZURE_MAP.layers['MFE'],
            window._AZURE_MAP.layers['CORE'],
            window._AZURE_MAP.layers['CERT'],
            window._AZURE_MAP.layers['PREM']
        ], function () {
            window._AZURE_MAP.map.getCanvasContainer().style.cursor = 'gr';
        });

        window._AZURE_MAP.map.events.add('click', [
            window._AZURE_MAP.layers['RETAILER'],
            window._AZURE_MAP.layers['MFE'],
            window._AZURE_MAP.layers['CORE'],
            window._AZURE_MAP.layers['CERT'],
            window._AZURE_MAP.layers['PREM']
        ], function (e) {
            onClickCallback(e.shapes[0].getProperties().id);
            // window._AZURE_MAP.showPopup(e.shapes[0]);
        });

    });
};

const makeDataSource = function (sourceType) {
    window._AZURE_MAP.dataSources[sourceType] = new atlas.source.DataSource(null, {
        cluster: false
    });

    window._AZURE_MAP.map.sources.add(window._AZURE_MAP.dataSources[sourceType]);
};

const clearDatasource = function (sourceType) {
    window._AZURE_MAP.dataSources[sourceType].clear();
};

const clearDataSources = function () {
    window._AZURE_MAP.popup.close();

    window._AZURE_MAP.boundingList = [];

    for (const key in window._AZURE_MAP.dataSources) {
        clearDatasource(key);
    }
};

const makeLayer = function (sourceType, sourceIcon) {
    window._AZURE_MAP.layers[sourceType] = new atlas.layer.SymbolLayer(window._AZURE_MAP.dataSources[sourceType], null, {
        iconOptions: {
            image       : sourceIcon,
            size        : 1,
            allowOverlap: true,
            anchor      : 'center',
        }
    });

    window._AZURE_MAP.map.layers.add(window._AZURE_MAP.layers[sourceType]);
};

const showPopup = function (shape) { 

    const properties = shape.getProperties();

    const html = ['<div class="tw-p-4" style="max-width: 600px">'];
    html.push('<div class="tw-uppercase tw-font-bold tw-text-sm">' + properties.displayName + '</div>');
    html.push('<div class="tw-text-xs">');
    html.push(properties.street);
    html.push('</div>');
    html.push('<div class="tw-text-xs">');
    html.push(properties.city + ', ');
    html.push(properties.state + ', ');
    html.push(properties.postalCode);
    html.push('</div>');
    html.push('<div class="tw-text-xs tw-pt-2">');
    html.push('<a class="tw-underline hover:tw-no-underline" target="_blank" href="https://www.google.com/maps/dir//' + properties.street + ',' + properties.city + ',' + properties.state + ',' + properties.postalCode + '"> Get Directions</a>');
    html.push('</div>');
    html.push('</div>');

    window._AZURE_MAP.popup.setOptions({
        content    : html.join(''),
        position   : shape.getCoordinates(),
        pixelOffset: [0, 0]
    });

    window._AZURE_MAP.popup.open(window._AZURE_MAP.map);

};

const findAndShowPopup = function (item) {
    window._AZURE_MAP.popup.close();

    setTimeout(() => {
        const data = window._AZURE_MAP.map.layers.getRenderedShapes(window._AZURE_MAP.map.getCamera().bounds, [window._AZURE_MAP.layers[item.iconType]]);

        data.forEach(shape => {
            const properties = shape.getProperties();

            if (properties.id == item.id) {
                showPopup(shape);
            }
        });
    }, 300);
};

const addLocation = function (item) {
    const position = new atlas.data.Position(item.longitude, item.latitude);
    const point = new atlas.data.Point(position);

    const feature = new atlas.data.Feature(point, {
        iconType   : item.iconType,
        id         : item.id,
        displayName: item.displayName,
        street     : item.street,
        city       : item.city,
        state      : item.state,
        postalCode : item.postalCode
    });

    window._AZURE_MAP.boundingList.push(feature);

    window._AZURE_MAP.dataSources[item.iconType].add(feature);
};

const setCameraPositionByLongLat = function (longitude, latitude) {
    window._AZURE_MAP.map.setCamera({
        center: [longitude, latitude - 0.001]
    });
};

const setAutoCameraPosition = function (state) {
    setCameraPositionByLongLat(state.locations[0].longitude, state.locations[0].latitude - 0.001, 16);
};

const setCameraToBounds = function () {
    if (!window._AZURE_MAP.boundingList.length) {
        return;
        
    }

    window._AZURE_MAP.map.setCamera({
        bounds : atlas.data.BoundingBox.fromData(window._AZURE_MAP.boundingList),
        padding: 40
    });
};

const getGeoData = async function (countryCode, query) {
    return await axios.get(`https://atlas.microsoft.com/search/address/structured/json?api-version=1.0&countryCode=${countryCode}&postalCode=${query}&view=Auto&subscription-key=${window._AZURE_KEY}`).then(res => {

        if (!res.data.results || !res.data.results.length) {
            return false;
        }

        window._AZURE_MAP.geoCodedSearchData = res.data.results[0];

        return res.data.results[0];

    }).catch(() =>{
        return false;
    });
};

const distanceAway = function (state, longitude, latitude) {
    return Math.ceil(Math.round(atlas.math.getDistanceTo([window._AZURE_MAP.geoCodedSearchData.position.lon, window._AZURE_MAP.geoCodedSearchData.position.lat], [longitude, latitude], (state.distancePref == 'mi' ? 'miles' : 'kilometers')) * 100) / 100);
};

const closePopups = function () {
    window._AZURE_MAP.popup.close();
};

const zoomOut = function () {
    window._AZURE_MAP.map.setCamera({
        zoom: 5
    });
};

const zoomTo = function (zoomLevel) { 
    window._AZURE_MAP.map.setCamera({
        zoom: zoomLevel
    });
};

const currentZoomLevel = function () {
    return window._AZURE_MAP.map.getCamera().zoom;
};

const getLocationFromMapCenter = async function () {
    const center = window._AZURE_MAP.map.getCamera().center;

    return await axios.get(`https://atlas.microsoft.com/reverseGeocode?api-version=2023-06-01&coordinates=${center[0]},${center[1]}&subscription-key=${window._AZURE_KEY}`).then(res => {

        if (!res.data.features || !res.data.features.length) {
            return false;
        }

        let postalCode = false;

        res.data.features.forEach(feature => {
            if (!postalCode) {
                postalCode = feature?.properties?.address?.postalCode;
            }
        });

        return postalCode;

    }).catch(() =>{
        return false;
    });
};

export default {
    init,
    addEventListeners,
    makeDataSource,
    clearDataSources,
    closePopups,
    makeLayer,
    showPopup,
    addLocation,
    setCameraPositionByLongLat,
    setAutoCameraPosition,
    setCameraToBounds,
    getGeoData,
    distanceAway,
    findAndShowPopup,
    zoomOut,   
    zoomTo,
    currentZoomLevel,
    getLocationFromMapCenter 
};